import React, {useEffect, useState} from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Input, Select, Button, PhoneInput } from '@arnsbogroup/react-voicearchive'
import useValidate, { is } from '@arnsbogroup/react-voicearchive/hooks/useValidate'
import messages from './messages'

const Coordinator = () => {
  const { formatMessage } = useIntl()

  const initialNewCoordinator = {
    name: '',
    email: '',
    phone: {
      number: '',
      country: 'dk'
    },
    partner: 0
  }
  const [newCoordinator, setNewCoordinator] = useState(initialNewCoordinator)
  const [partnerOptions, setPartnerOptions] = useState([])

  const [validations, validate] = useValidate(newCoordinator, {
    name: [is.present],
    email: [is.present, is.email],
    phone: [is.present, is.phone]
  })

  const i18n = (errorMessages) => errorMessages?.map((errorMessage) => ({
    present: formatMessage(messages.errorsPresent),
    email:  formatMessage(messages.errorsEmail),
    phone:  formatMessage(messages.errorsPhone)
  }[errorMessage] || errorMessage))

  useEffect(() => {
    fetch('/rest/v2/partner')
    .then((response) => response.json())
    .then((data) => {
      setPartnerOptions(data.map((partner) => ({value: partner.uid, label: partner.name})))
    })
    .catch((err) => {
      toastr.error(err)
    })
  }, [])
  
  const onSubmit = (event) => {
    event.preventDefault()
    if (validate()) {
      newCoordinator.phone = newCoordinator.phone.number;
      fetch(`/rest/v2/user`, {
        method: 'POST',
        body: JSON.stringify(newCoordinator)
      })
      .then((response) => response.json())
      .then(() => {
          toastr.success('Coordinator created')
          setNewCoordinator(initialNewCoordinator)
        }
      )
    }
  }

  return (
    <div>
      <div className="font-medium text-4xl">
        <FormattedMessage {...messages.title } />
      </div>
      <div className="text-gray-700 mt-6 w-2/3">
        <FormattedMessage {...messages.subtitle } />
      </div>
      <div className='grid grid-cols-2 m-2 gap-4'>
        <div className='space-y-4'>
          <Input
              defaultValue=""
              value={newCoordinator.name}
              label={formatMessage(messages.coordinatorNameLabel)}
              description={formatMessage(messages.coordinatorNameDescription)}
              placeholder={formatMessage(messages.coordinatorNamePlaceholder)}
              onChange={({ target: { value } }) => setNewCoordinator({ ...newCoordinator, name: value })}
              onBlur={() => validate(['name'])}
              errors={i18n(validations.name)}
          />
          <Input
              defaultValue=""
              value={newCoordinator.email}
              label={formatMessage(messages.coordinatorEmailLabel)}
              description={formatMessage(messages.coordinatorEmailDescription)}
              placeholder={formatMessage(messages.coordinatorEmailPlaceholder)}
              onChange={({ target: { value } }) => setNewCoordinator({ ...newCoordinator, email: value })}
              onBlur={() => validate(['email'])}
              errors={i18n(validations.email)}
          />
        </div>
        <div className='space-y-4'>
          <PhoneInput
            country={initialNewCoordinator.phone.country}
            enableSearch
            disableSearchIcon
            searchPlaceholder={formatMessage(messages.phoneNumberSearchPlaceholder)}
            searchNotFound={formatMessage(messages.phoneNumberNotFoundPlaceholder)}
            value={newCoordinator.phone.number}
            label={formatMessage(messages.coordinatorPhoneLabel)}
            description={formatMessage(messages.coordinatorPhoneDescription)}
            placeholder={formatMessage(messages.coordinatorPhonePlaceholder)}
            onChange={(phone, country) => {
              const data = {
                number: '+' + phone,
                country: country.countryCode
              };
              setNewCoordinator({ ...newCoordinator, phone: data })
            }}
            onBlur={() => validate(['phone'])}
            errors={i18n(validations.phone)}
          />
          <Select
            label={formatMessage(messages.coordinatorPartnerLabel)}
            description={formatMessage(messages.coordinatorPartnerDescription)}
            placeholder={formatMessage(messages.coordinatorPartnerPlaceholder)}
            value={ partnerOptions.find(partner => newCoordinator.partner == partner.value) }
            options={ partnerOptions }
            onChange={(partner) => setNewCoordinator({ ...newCoordinator, partner: partner.value })}
          />
        </div>
      </div>
      <div className='float-right'>
      <Button
        onClick={(e) => onSubmit(e)}
      >
        <FormattedMessage {...messages.submit} />
      </Button>
      </div>
    </div>
  )
}

export default Coordinator
